export const PAUSE = "pause";
export const PLAY = "play";
export const SEEK = "seek";
export const NEXT_CHAPTER = "nextChapter";
export const PREVIOUS_CHAPTER = "previousChapter";
export const GO_TO_CHAPTER = "goToChapter";
export const GO_TO_CHAPTER_ID = "goToChapterId";
export const NEXT_SLIDE = "nextSlide";
export const PREVIOUS_SLIDE = "previousSlide";
export const GO_TO_SLIDE = "goToSlide";
export const NAVIGATE_BACK = "back";
export const TOGGLE_FULLSCREEN = "fullscreen";
export const SET_CAPTION_LANGUAGE = "captionLanguage";
export const TOGGLE_CHAPTER_LIST_VISIBILITY = "toggleChapterListVisibility";
export const SET_CHAPTER_LIST_VISIBILITY = "setChapterListVisibility";
export const SET_VISIBLE_TILE = "goToTile";
/**
 * Reset the player's indivual chapter progress
 */
export const RESET = "reset";
